import { Camera, Send } from 'lucide-react'
import {
  useTriggerSnapshot,
  useTriggerStorageReport,
} from '../../api/admin-stripe'
import { OrgStorageTable } from './OrgStorageTable'

/**
 * "Storage" tab — cross-org sortable storage table + manual triggers.
 *
 * The kill-switch displayed here is read-only; flip it via the Stripe
 * tab's Pricing Config panel. We just surface the current state so the
 * operator knows whether "Report now" will actually do anything.
 */
export function AdminBillingStorageTab() {
  const triggerSnap = useTriggerSnapshot()
  const triggerReport = useTriggerStorageReport()
  return (
    <div className="space-y-6">
      <section className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-border bg-surface p-4">
        <div>
          <div className="font-medium">Manual triggers</div>
          <div className="text-xs text-text-secondary">
            The snapshotter runs daily; the storage reporter runs daily and is
            gated by both env and DB kill-switches. Use these for smoke-testing.
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={() => triggerSnap.mutate()}
            disabled={triggerSnap.isPending}
            className="inline-flex items-center gap-1 rounded-lg border border-border bg-background px-3 py-2 text-sm hover:bg-surface-elevated disabled:opacity-50"
            title="StorageSnapshotter.snapshot_once()"
          >
            <Camera className={`h-3.5 w-3.5 ${triggerSnap.isPending ? 'animate-pulse' : ''}`} />
            Snapshot now
          </button>
          {triggerSnap.data && (
            <span className="text-xs text-text-secondary">
              {triggerSnap.data.upserts} upsert(s)
            </span>
          )}
          <button
            onClick={() => triggerReport.mutate()}
            disabled={triggerReport.isPending}
            className="inline-flex items-center gap-1 rounded-lg border border-border bg-background px-3 py-2 text-sm hover:bg-surface-elevated disabled:opacity-50"
            title="StripeStorageReporter.report_once()"
          >
            <Send className={`h-3.5 w-3.5 ${triggerReport.isPending ? 'animate-pulse' : ''}`} />
            Report now
          </button>
          {triggerReport.data && (
            <span className="text-xs text-text-secondary">
              {triggerReport.data.reported} reported
            </span>
          )}
        </div>
      </section>

      <OrgStorageTable />
    </div>
  )
}
